module.exports = __webpack_public_path__ + "static/media/about.47b2f32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about.png
// module id = 30
// module chunks = 0